var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","fill":"#002378","d":"M15.387,2.659 C15.387,2.659 7.108,10.425 7.108,10.425 C6.495,11.000 5.501,11.000 4.887,10.425 C4.887,10.425 0.613,6.416 0.613,6.416 C-0.000,5.840 -0.000,4.907 0.613,4.332 C1.227,3.757 2.221,3.757 2.834,4.332 C2.834,4.332 5.998,7.300 5.998,7.300 C5.998,7.300 13.166,0.575 13.166,0.575 C13.779,-0.000 14.774,0.000 15.387,0.575 C16.000,1.151 16.000,2.083 15.387,2.659 Z"})));
}

Icon.defaultProps = {"version":"1.1","baseProfile":"full","xmlnsEv":"http://www.w3.org/2001/xml-events","width":"16","height":"11","viewBox":"0 0 16 11"};

module.exports = Icon;

Icon.default = Icon;
